import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
@Pipe({
  name: 'SectionProgressPipe'
})
export class SectionProgressPipe implements PipeTransform {
  transform(section, form_group, form_value, progress_object, claculate_for_all = 0) {
    try {

      if ((section && section.active) || claculate_for_all) {
        // if (section && section.sections && section.sections.length) {
        //   let all_child_section_progress = 0;
        //   for (let i = 0; i < (section.sections).length; i++) {
        //     let child_section = section.sections[i]
        //     all_child_section_progress = all_child_section_progress + getSectionProgress(child_section, (form_group.get((section.title).toString())).get((child_section['section_id']).toString()))
        //   }

        //   return Math.round(((all_child_section_progress + getSectionProgress(section, form_group)) / (section.sections.length + 1)))
        // }
        // else {
        return getSectionProgress(section, (form_group.get((section.title).toString())) ? (form_group.get((section.title).toString())) : form_group, progress_object)
        // }
      }
      else {
        return section.progressPercentage || 0
      }


    } catch (err) {

    }
  }
}


export function getSectionProgress(section, form_group, progres_object) {
  try {
    let enable_progress_fields = section.enable_progress_fields || [];
    let gainedProgressValue = 0;
    if (enable_progress_fields.length) {
      if (section.multiple) {
        return 100;
      }
      else {
        for (let i = 0; i < enable_progress_fields.length; i++) {
          let enable_progress_field = enable_progress_fields[i];
          if (form_group.get(enable_progress_field.title) && form_group.get(enable_progress_field.title).valid && (form_group.get(enable_progress_field.title).value || (form_group.get(enable_progress_field.title).value == 0 && form_group.get(enable_progress_field.title).value != ''))) {
            gainedProgressValue = gainedProgressValue + ((progres_object[enable_progress_field['dataStatus']]) / 100);
          }
        }
        section.progressPercentage = Math.floor((gainedProgressValue / enable_progress_fields.length) * 100);
        return section.progressPercentage
      }
    }
    else {
      // if (section && form_group) {
      //   let controls = Object.keys(form_group.controls);
      //   try {
      //     for (let i = 0; i < controls.length; i++) {
      //       let control = controls[i];
      //       // console.log(hasValidator(form_group, control, 'required'))
      //       if (form_group.get(control) && form_group.get(control).valid && (form_group.get(control).value || (form_group.get(control).value == 0 && form_group.get(control).value != ''))) {
      //         gainedProgressValue = gainedProgressValue + ((progres_object[control['dataStatus']]) / 100);
      //       }
      //     }
      //   } catch (error) {
      //     console.table(error)
      //   }
      //   section.progressPercentage = Math.floor((gainedProgressValue / section.validation_count) * 100);
      //   return section.progressPercentage
      // }
      return 100;
    }

  } catch (err) {
    console.log(err)
  }
}

export function checkEnableProgress(section, field) {
  try {
    if (!(section.enable_progress && field.enable_progress)) {
      if (section.enable_progress_fields && section.enable_progress_fields.length && typeof section.enable_progress_fields == 'object') {
        section.enable_progress_fields.push(field)
      }
      else {
        section.enable_progress_fields = [];
        section.enable_progress_fields.push(field)
      }
    }
  }
  catch (err) {

  }
}

// 